import { useEffect, useState } from 'react';

const faqs = [
  {
    q: '这里的“现场直击”和网上的小道消息有什么区别？',
    a: '现场直击坚持“先核实、后还原”的原则。编辑与特约观察员会基于现场记录、多方信源与公开资料交叉核对，再按时间线逐段还原经过。来源无法确认、仅停留在猜测层面的内容，我们不会以“实况”呈现。',
  },
  {
    q: '我在热搜榜上看到的热度数字是怎么计算出来的？',
    a: '榜单热度综合了实时阅读、讨论、转发与话题参与等多个维度的加权估算，用于直观反映某一话题当下被围观的激烈程度，仅代表讨论量的大小，不代表事件本身的对错。数据会随刷新动态变化。',
  },
  {
    q: '遇到双方各执一词的争议事件，吃瓜时应该先信哪一方？',
    a: '在没有权威结论前，不妨先“悬置判断”。关注事实陈述与可验证的证据，而不是情绪化的表态。多数反转都发生在证据陆续浮出水面之后，保持一点耐心，往往能少走很多弯路。',
  },
  {
    q: '怎样才能避免在围观热点时被“带节奏”？',
    a: '可以尝试做到三点：一看发布者与信源是否可靠，二看标题与正文是否一致，三看是否只截取了片段。当一件事越“非黑即白”地绝对时，越要提醒自己可能存在信息缺口。理性围观，从吃瓜不站队开始。',
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(faqSchema);
    script.setAttribute('data-schema', 'faq');
    document.head.appendChild(script);
    return () => {
      document.head.querySelectorAll('script[data-schema="faq"]').forEach((s) => s.remove());
    };
  }, []);

  return (
    <section id="guide" className="w-full scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-question-mark" aria-hidden="true" /> GUCHANG GUIDE
            </p>
            <h2 className="mt-2 font-display text-2xl font-black md:text-3xl">吃瓜指南 · 常见问题</h2>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              围观一时爽，但吃得明白才更安心。这里整理了新老吃瓜人最常问的几个问题，帮你快速上手，成为懂门道的老手。
            </p>
            <div className="mt-6 hidden rounded-2xl bg-secondary-100 p-5 lg:block">
              <p className="font-display text-sm font-bold text-secondary-900">一句话口诀</p>
              <p className="mt-2 text-sm leading-6 text-secondary-800">多看信源、少下结论、让子弹飞一会儿。</p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <ul className="space-y-3">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <li key={i} className="overflow-hidden rounded-2xl bg-background-50">
                    <button type="button" onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen} className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left">
                      <span className="font-display text-sm font-bold text-foreground-950 md:text-base">{f.q}</span>
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'}`}>
                        <i className={`transition-transform ${isOpen ? 'rotate-180' : ''} text-sm ri-add-line`} aria-hidden="true" />
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5">
                        <p className="border-l-2 border-accent-300 pl-3 text-sm leading-7 text-foreground-700">{f.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}